import type { GameSide, GameType } from '../chatv1/transport'
import type { IconName } from '../ui/Icon'
import { gomokuOn, xiangqiOn } from './flag'

/**
 * The games in the list, in the owner's order (2026-10-19: 西洋棋 … 之後再做五子棋; then xiangqi, shogi, mahjong — one
 * at a time, each shown only once it is built). Everything the screens say differently per game is here; the rules
 * themselves are the service's (chat lambda/chess.ts, gomoku.ts, xiangqi.ts).
 */
export type GameKind = {
  type: GameType
  title: string
  /** In a sentence: "a game of chess". */
  noun: string
  icon: IconName
  /** One line under the name in the list. */
  sub: string
  /** The side that moves first — White in chess, Black in gomoku, Red in xiangqi — listed first where a side is picked. */
  first: GameSide
  /** What the two sides are called. */
  sides: Record<GameSide, string>
}

const WHITE_BLACK: Record<GameSide, string> = { w: 'White', b: 'Black' }

const ALL_KINDS: readonly GameKind[] = [
  { type: 'chess', title: 'Chess', noun: 'chess', icon: 'chess_knight', sub: '2 players · or your agent', first: 'w', sides: WHITE_BLACK },
  { type: 'gomoku', title: 'Gomoku', noun: 'gomoku', icon: 'grid_on', sub: 'Five in a row', first: 'b', sides: WHITE_BLACK },
  { type: 'xiangqi', title: 'Xiangqi', noun: 'xiangqi', icon: 'toll', sub: 'Chinese chess', first: 'w', sides: { w: 'Red', b: 'Black' } },
]

/** The games the list offers in this build (flag.ts can switch one off). */
export function listedKinds(): GameKind[] {
  return ALL_KINDS.filter((k) => (k.type === 'gomoku' ? gomokuOn() : k.type === 'xiangqi' ? xiangqiOn() : true))
}

/** A game's words and picture, whether or not this build lists it (a game, once made, is always shown as itself). */
export function kindOf(type: GameType | string | undefined): GameKind {
  return ALL_KINDS.find((k) => k.type === type) ?? ALL_KINDS[0]!
}
